<template>
  <div
    v-if="!disabled_pass && !disabled"
    class="w-max-content w-max cursor-pointer flex hover:font-medium items-center"
    @click="del()"
  >
    <span class="minus-button 2xl:h-10 2xl:w-10 2xl:mt-2">
      <icon name="close" />
    </span>
    <span
      v-if="libelle != ''"
      class="text-base text-gray-600 ml-3 flex-initial"
    >
      {{ libelle }}
    </span>
  </div>
</template>

<script>
import Icon from './../Icon';

export default {
  name: 'DeleteButton',
    
  components:{
    Icon,
  },
    
  props:{
    libelle: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data: function () {
    return {
      disabled_pass: false,
    };
  },

  mounted(){
    // Manage edit permission for neopass pages
    if(this.$route.path.includes('form/neopass')){
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];

      if(this.$can(page+'_edit', idpass)){
        this.disabled_pass = false;
      }
      else{
        this.disabled_pass =  true;
      }
    }else{
      this.disabled_pass = false;
    }
  },

  methods:{
    del(){
      this.$emit('del');
    }
  }
};
</script>